import { forwardRef } from "react";

const SecondaryButton = forwardRef(function (
  { type = "button", className = "", disabled, children, ...props },
  ref
) {
  return (
    <button
      {...props}
      type={type}
      ref={ref}
      className={
        `inline-flex items-center px-3.5 py-2  border border-zinc-300 rounded-xl font-semibold text-sm text-white shadow-sm shadow-black/[0.05]  focus:outline-none ring-2 ring-transparent disabled:opacity-25 transition select-none ease-in-out duration-150 ${
          disabled && "opacity-25"
        } ` + className
      }
      disabled={disabled}
    >
      {children}
    </button>
  );
});

export default SecondaryButton;
